import { createContext, useContext, useState, useCallback, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [employee, setEmployee] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [loading, setLoading] = useState(true);

  const api = useCallback(() => {
    const instance = axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });
    instance.interceptors.response.use(r => r, err => {
      if (err.response?.status === 401) { logout(); }
      return Promise.reject(err);
    });
    return instance;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const login = useCallback(async (username, password) => {
    const res = await axios.post(`${API}/auth/login`, { username, password });
    const { token: t, user: u, employee: e } = res.data;
    localStorage.setItem("token", t);
    setToken(t);
    setUser(u);
    setEmployee(e);
    return res.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
    setEmployee(null);
  }, []);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(res => { setUser(res.data.user); setEmployee(res.data.employee); })
        .catch(() => { logout(); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token, logout]);

  return (
    <AuthContext.Provider value={{ user, employee, token, login, logout, loading, api, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { API, BACKEND_URL };
